module.exports = __webpack_public_path__ + "img/shipo-map-poi-port.39e3f81f.svg";